export const TEXTS = {
  CONNECT_WITH_MANAGER_BUTTON_TEXT: 'Связаться с менеджером',
};
